function scoreByCity(user, match, cityScore) {
    let score = 0;
    let studentCities;
    let parentCity;
    if (user.type === "student") {
        studentCities = user.cities;
        parentCity = match.city;
    } else {
        studentCities = match.cities;
        parentCity = user.city;
    }

    studentCities.forEach(function (city) {
        if(city.name === parentCity){
            score += cityScore;
        }
    });
    return score
}

function rank(user, matchList, matchFields, cityScore) {
    let matchesDict = [];
    matchList.forEach(function (match) {
        let score = scoreByCity(user, match,cityScore);
        matchFields.forEach(item => {
            if (item.field in user) {
                if (user[item.field] === match[item.field]) {
                    score += item.value;
                }
            }
        });
        matchesDict.push({
            attribute: match,
            rank: score
        })
    });
    return matchesDict;
}

exports.rank = rank;